// extracted by mini-css-extract-plugin
export default {"headline":"LoadProductPortfolios_headline__UCLSs"};